export default __webpack_public_path__ + "static/media/arrow_left.34433ec6.svg";